import { maxLengthParser, onlyNumbersParser } from '../../../lib/form/utils';
import { PREPAID_SECURITY_CODE_LENGTH } from '../../../pages/AddCard/vault-card.schema';

export const parseSecurityCode = (value: string) =>
  maxLengthParser(onlyNumbersParser(value), PREPAID_SECURITY_CODE_LENGTH);
